import { Optional } from '@/generic/functional';
import { RuleExtractionId } from '@/rules-management/domain/RuleExtraction.ts';

const STORAGE_KEY = 'cleanapi.rules-management.extraction-tracking';

export const saveTrackedExtraction = (id: RuleExtractionId): void => {
  sessionStorage.setItem(STORAGE_KEY, id.value);
};

export const loadTrackedExtraction = (): Optional<RuleExtractionId> =>
  Optional.ofNullable(sessionStorage.getItem(STORAGE_KEY)).map(RuleExtractionId.of);

export const clearTrackedExtraction = (): void => {
  sessionStorage.removeItem(STORAGE_KEY);
};
